"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _default = function _default(Dispatch, client) {
  var executeRequest = function executeRequest(request) {
    var variables = request.variables ? request.variables : {};
    return (0, _rxjs.of)(1).pipe((0, _operators.tap)(function (e) {
      if (request.type !== 'query' && request.type !== 'mutation') {
        throw new Error("Invalid Request Type (should be query or mutation)");
      }
    }), (0, _operators.mergeMap)(function () {
      return (request.type === 'query' ? (0, _rxjs.from)(client.query({
        query: request.query,
        variables: variables
      })) : (0, _rxjs.from)(client.mutate({
        mutation: request.query,
        variables: variables
      }))).pipe((0, _operators.map)(function (response) {
        if (request.retry && response.errors) {
          throw new Error(response.errors);
        }

        return response;
      }));
    }), (0, _operators.retryWhen)(function (err) {
      return err.pipe((0, _operators.mergeMap)(function (error, i) {
        var attempts = i + 1;

        if (request.retry && attempts < (request.attempts ? request.attempts : 1000000000)) {
          return (0, _rxjs.of)(1).pipe((0, _operators.delay)(request.retry * attempts));
        } else {
          return (0, _rxjs.throwError)(error);
        }
      }));
    }));
  };

  Dispatch.getAction('Request.*').pipe((0, _operators.groupBy)(function (e) {
    return e.id;
  }), (0, _operators.mergeMap)(function (group) {
    return group.pipe((0, _operators.map)(function (e) {
      return e.value;
    }), (0, _operators.switchMap)(function (request) {
      return (request.poll ? (0, _rxjs.timer)(0, request.poll) : (0, _rxjs.of)(1)).pipe((0, _operators.switchMap)(function () {
        return executeRequest(request).pipe((0, _operators.catchError)(function (err) {
          return (0, _rxjs.of)({
            errors: err.message
          });
        }));
      }), (0, _operators.map)(function (response) {
        return {
          id: group.key,
          response: response
        };
      }));
    }));
  })).subscribe(function (e) {
    return Dispatch.nextAction('Response.' + e.id, e.response);
  });
};

exports["default"] = _default;
//# sourceMappingURL=request.js.map